import { useLayoutEffect } from 'react';

import { usePreferencesStore } from '@/stores/preferences';

/**
 * 글자 크기 선호를 <html data-font-size> 로 반영한다 — 전 화면(FO·워크스페이스) 공통.
 * <html> 인 이유: 루트 font-size 배율이라 rem 스케일 전체와 body 로 포털되는 모달·시트·메뉴까지 같이 커진다.
 */
export function useRootFontSize() {
  const fontSize = usePreferencesStore((s) => s.fontSize);

  useLayoutEffect(() => {
    const root = document.documentElement;
    if (fontSize === 'md') delete root.dataset.fontSize;
    else root.dataset.fontSize = fontSize;
  }, [fontSize]);
}
